var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.filter.inputs.mode.options, function(opt) {
        return _c("div", { key: opt.value, staticClass: "form-group" }, [
          _c("label", { staticClass: "form-label label-auto" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mode,
                  expression: "mode"
                }
              ],
              attrs: { type: "radio", name: "mode" },
              domProps: {
                value: opt.value,
                checked: _vm._q(_vm.mode, opt.value)
              },
              on: {
                change: function($event) {
                  _vm.mode = opt.value
                }
              }
            }),
            _vm._v("\n\t\t\t" + _vm._s(opt.label) + "\n\t\t")
          ])
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-group form-group-32" }, [
        _vm.mode != "without" && _vm.mode != "with"
          ? _c(
              "div",
              { staticClass: "form-input span_12" },
              [
                _c("autocomplete", {
                  attrs: {
                    type: "tag",
                    params: {
                      type: this.filter.inputs.value.params.linkedtype
                    },
                    prepopulate: _vm.value,
                    name: _vm.filter.name,
                    minChars: 1
                  },
                  on: { updated: _vm.updateAutocomplete }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }